import { defineStore } from 'pinia'
import specialtiesData from '@/data/specialties.json'

export const useAppStore = defineStore('app', {
  state: () => ({
    specialtyOptions: specialtiesData,
    selectedSpecialtyName: '',
    selectedSpecialtyVisitType: null,
    visitType: '',
  }),

  getters: {
    selectedDepartmentIds: (state) => {
      const specialty = state.specialtyOptions.find((s) => s.name === state.selectedSpecialtyName)
      return specialty?.departmentIds.join(',') || ''
    },
    selectedProviders: (state) => {
      const specialty = state.specialtyOptions.find((s) => s.name === state.selectedSpecialtyName)
      return specialty?.providerIds.join(',') || ''
    },
  },

  actions: {
    setSelectedSpecialty(specialtyName) {
      const specialty = this.specialtyOptions.find((s) => s.name === specialtyName)

      this.$patch({
        selectedSpecialtyName: specialtyName,
        selectedSpecialtyVisitType: specialty?.visitType || '',
      })
    },
  },
})
